
        import { QuickConverterTool } from '../../src/tools/quick-converter/QuickConverterTool';
        import '../../src/utils/emojiManager';

        document.addEventListener('DOMContentLoaded', async () => {
            const tool = new QuickConverterTool({
                sourceFormat: 'bmp',
                targetFormat: 'jpg',
            });
            await tool.init();
        });
    